import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-dc9fe3d2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header_lang_area" }
const _hoisted_2 = { class: "header_lang" }
const _hoisted_3 = { style: {"display":"flex","align-items":"center"} }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "https://www.beian.suzhou.gov.cn/license?id=1186174914034401342",
  target: "_blank"
}, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "http://www.beian.suzhou.gov.cn/resources/images/marker/szicbok.gif",
    style: {"width":"20px","margin-left":"10px"},
    alt: ""
  })
], -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "https://www.beian.gov.cn/portal/registerSystemInfo?recordcode=32050502012539",
  rel: "noreferrer",
  target: "_blank"
}, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "http://www.beian.gov.cn/img/ghs.png",
    style: {"width":"20px","margin-left":"10px"},
    alt: ""
  })
], -1))
const _hoisted_6 = {
  key: 0,
  style: {"color":"#cccccc","margin-left":"10px"},
  href: "https://beian.mps.gov.cn/#/query/webSearch?code=32050502012539",
  target: "_blank"
}
const _hoisted_7 = {
  key: 1,
  style: {"color":"#cccccc","margin-left":"10px"},
  href: "https://beian.miit.gov.cn/",
  target: "_blank"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("span", { style: {"padding":"0 10px"} }, "Tel: 86-512-6616 5970"),
  /*#__PURE__*/_createElementVNode("span", null, "Email: infor@wdint.com")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_header_view = _resolveComponent("header-view")!
  const _component_el_header = _resolveComponent("el-header")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_footer_view = _resolveComponent("footer-view")!
  const _component_el_main = _resolveComponent("el-main")!
  const _component_el_footer = _resolveComponent("el-footer")!
  const _component_el_container = _resolveComponent("el-container")!

  return (_openBlock(), _createBlock(_component_el_container, { id: "layout" }, {
    default: _withCtx(() => [
      _createVNode(_component_el_header, { class: "header_area" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("span", {
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.changeLanguage('en'))),
                style: {"border-right":"1px solid #fff"}
              }, "English"),
              _createElementVNode("span", {
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.changeLanguage('zhCn'))),
                style: {"border-right":"1px solid #fff"}
              }, "中文"),
              _createElementVNode("span", {
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.changeLanguage('ja')))
              }, "日本语")
            ])
          ]),
          _createVNode(_component_header_view)
        ]),
        _: 1
      }),
      _createVNode(_component_el_main, { class: "main_area" }, {
        default: _withCtx(() => [
          _createVNode(_component_router_view),
          _createVNode(_component_footer_view, { class: "footer_view_area" })
        ]),
        _: 1
      }),
      _createVNode(_component_el_footer, {
        class: _normalizeClass(["footer_area", { 'fixed_bottom': _ctx.isFooterFixed }])
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            _createTextVNode(" © 2018 " + _toDisplayString(_ctx.$t('companyName')) + "     ", 1),
            _hoisted_4,
            _hoisted_5,
            (_ctx.locale === 'zh_CN')
              ? (_openBlock(), _createElementBlock("a", _hoisted_6, "苏公网安备32050502012539号"))
              : _createCommentVNode("", true),
            (_ctx.locale === 'zh_CN')
              ? (_openBlock(), _createElementBlock("a", _hoisted_7, "苏ICP备11026994号-1"))
              : _createCommentVNode("", true)
          ]),
          _hoisted_8
        ]),
        _: 1
      }, 8, ["class"])
    ]),
    _: 1
  }))
}